import { parse } from 'csv-parse/browser/esm/sync';
import { CardValidateResult } from '../models/CardValidateResult';

export class TextDeckReader {

    public static async openTextDeckAsync(file: File) {
        if (file.size >= 4e+6/* 4MB */) {
            throw new Error('ファイルサイズが大きすぎます。');
        }

        let prefix = '';
        if (window.location.hostname === 'localhost') {
            prefix = 'http://localhost/osica-member';
        } else {
            prefix = '/member';
        }

        const formData = new FormData();
        formData.append('file', file);

        //APIサーバーにアップロードして検証する
        const response = await fetch(prefix + "/api/cardapi/parse-deck", {
            method: 'POST',
            cache: 'no-cache',
            body: formData
        });

        const returnObject = await response.json();
        if (!response.ok) {
            console.error('Server return status code: ', response.status);
            console.log(returnObject);
            throw new Error('サーバー上でエラーが発生しました。');
        }

        //検証結果をデッキに挿入する
        const result = returnObject as CardValidateResult;
        return result;
    }

}